import { ComboBox, DefaultButton, IColumn, IComboBox, IComboBoxOption, ICommandBarItemProps, Panel, Persona, PersonaSize, PrimaryButton, TextField, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBoolean } from "@fluentui/react-hooks";
import { AuthContext } from "../../../auth/context/auth-context";
import { IUserAuthenticate } from "../../../auth/interface/IAuth";
import { TableBase } from "../../../components/Table/TableBase"
import { IException, IItemComboBaseDTO, IReportTelerik, ISearch } from "../../../interfaces/base/IBase";
import AuthService from "../../../services/AuthService";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import { CLAIM_EMPRESA_USUARIO_ID, isRoleAccessAll, roleAdmin, ROLE_TRANSPORTE } from "../../../utils/Helper/roleHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import { IFilterAsignacion, IFilterProgramacion, IProgramacionPersona } from "../../../interfaces/IProgramacion";
import { baseImageUrl, splitExceptionDetail, _initialFilter, _initialPagination, IndexNone, ItemNoneSelect } from "../../../utils/Helper/helper";
import { IDataCollection, IPagination } from "../../../interfaces/base/ITable";
import { _initialDataCollection } from "../../../utils/Helper/tableHelper";
import ProgramacionPersonaService from "../../../services/programacionPersonaService";
import RepoteBaseGenerico from "../../../components/Generic/ReporteBaseGenerico";
import { Ifilter } from "../../../interfaces/IFilter";
import { UbicacionHelper } from "../../../utils/Helper/ubicacionHelper";
import { IFilterUbicacion } from "../../../interfaces/filter/IFilterUbicacion";
import UbicacionService from "../../../services/ubicacionesServices";
import ConfiguracionService from "../../../services/configuracionService";
import OrganigramaService from "../../../services/organigramaService";
import ProgramacionService from "../../../services/ProgramacionService";

const reportByRole = (access: IUserAuthenticate | null, id: string) => {
  let role = access?.role ?? [];

  let transporteId = null;

  let isRolAdmin = isRoleAccessAll(role, roleAdmin());

  if (!isRolAdmin) {
    let isRolTransporte = isRoleAccessAll(role, [ROLE_TRANSPORTE]);

    if (isRolTransporte) {
      transporteId = AuthService.getInfoToken(CLAIM_EMPRESA_USUARIO_ID);
    }
  }

  let report: IReportTelerik = {
    reportName: 'MOVProgramadoPersonaTransporte.trdx',
    param: {
      programacionId: id,
      EmpresaId: transporteId
    }
  }

  return report;
}

export const ListarInscritoBus = ({ programacionId = '' }) => {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);

  const [isOpenFiltro, { setTrue: openFiltro, setFalse: dismissFiltro }] =
    useBoolean(false);

  /* Access & Role */
  const { access } = useContext(AuthContext);
  let role = access?.role ?? [];

  /* Data & Colum */
  const [data, setData] = useState<IDataCollection<IProgramacionPersona>>(_initialDataCollection);
  const [column, setColumn] = useState<IColumn[]>([]);

  /* Filter */
  const [filter, setFilter] = useState<IFilterProgramacion>({
    ..._initialFilter(),
    programacionId: programacionId,
  });

  /* Report */
  let reportTelerik = reportByRole(access as IUserAuthenticate, programacionId as string);
  const [isOpenTelerik, { setTrue: openTelerik, setFalse: dismissTelerik }] = useBoolean(false);

  /* Pagination */
  const [currentPage, setCurrentPage] = useState(_initialPagination().currentPage);
  const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
  const [total, setTotal] = useState(_initialPagination().total);
  const [filtroTabla, setFiltroTabla] = useState(false);

  const [pager, setPager] = useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => dataByPager(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });

  const refCampamento = React.useRef<IComboBox>(null);
  const refEmpresa = React.useRef<IComboBox>(null);
  const refGerencia = React.useRef<IComboBox>(null);
  const refLugarMovilizacion = React.useRef<IComboBox>(null);

  const [campamento, setCampamento] = useState<IItemComboBaseDTO[]>([]);
  const [empresa, setEmpresa] = useState<IItemComboBaseDTO[]>([]);
  const [gerencia, setGerencia] = useState<IItemComboBaseDTO[]>([]);
  const [lugarMovilizacion, setLugarMovilizacion] = useState<IItemComboBaseDTO[]>([]);

  const _openCampamento = React.useCallback(
    () => refCampamento.current?.focus(true),
    []
  );
  const _openEmpresa = React.useCallback(
    () => refEmpresa.current?.focus(true),
    []
  );
  const _openGerencia = React.useCallback(
    () => refGerencia.current?.focus(true),
    []
  );
  const _openLugarMovilizacion = React.useCallback(
    () => refLugarMovilizacion.current?.focus(true),
    []
  );


  const [filterCampamento, setFilterCampamento] = useState<ISearch>(_initialFilter);
  const [filterEmpresa, setFilterEmpresa] = useState<ISearch>(_initialFilter);
  const [filterGerencia, setFilterGerencia] = useState<ISearch>(_initialFilter);
  const [filterLugarMovilizacion, setFilterLugarMovilizacion] = useState<ISearch>(_initialFilter);
  const [filterBusVigente, setFilterBusVigente] = useState<Ifilter>(_initialFilter);

  const [selBusForm, setSelBusForm] = useState<IComboBoxOption>(null!);


  const _onInputDestino = (e: React.KeyboardEvent<IComboBox>) => {
    _openCampamento();
    let { value } = e?.target as HTMLInputElement;

    if (filter.campamentoId != null) {
      setFilter({
        ...filter,
        campamentoId: null,
      });
    }

    setFilterCampamento({
      ...filterCampamento,
      search: value,
    });
  };

  const _onInputEmpresa = (e: React.KeyboardEvent<IComboBox>) => {
    _openEmpresa();
    let { value } = e?.target as HTMLInputElement;

    if (filter.empresaPersonaId != null) {
      setFilter({
        ...filter,
        empresaPersonaId: null,
      });
    }

    setFilterEmpresa({
      ...filterEmpresa,
      search: value,
    });
  };

  const _onInputGerencia = (e: React.KeyboardEvent<IComboBox>) => {
    _openGerencia();
    let { value } = e?.target as HTMLInputElement;

    if (filter.gerenciaId != null) {
      setFilter({
        ...filter,
        gerenciaId: null,
      });
    }

    setFilterGerencia({
      ...filterGerencia,
      search: value,
    });
  };

  const _onInputLugarMovilizacion = (e: React.KeyboardEvent<IComboBox>) => {
    _openLugarMovilizacion();
    let { value } = e?.target as HTMLInputElement;

    if (filter.lugarMovilizacionId != null) {
      setFilter({
        ...filter,
        lugarMovilizacionId: null,
      });
    }

    setFilterLugarMovilizacion({
      ...filterLugarMovilizacion,
      search: value,
    });
  };

  const dataCampamento = () => {
    setCampamento([]);

    const filterDestino: IFilterUbicacion = {
      tipo: UbicacionHelper.TIPO_DESTINO,
      search: filterCampamento.search,
    };

    UbicacionService.ubicacionPorFiltro(filterDestino)
      .then((res) => {
        let t: IItemComboBaseDTO[] = res.data;
        t.unshift(ItemNoneSelect());
        setCampamento(t);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const dataEmpresa = () => {
    setEmpresa([]);
    ConfiguracionService.allEmpresa(filterEmpresa)
      .then((res) => {
        if (res.status == 200) {
          let t: IItemComboBaseDTO[] = res.data;
          t.unshift(ItemNoneSelect());

          setEmpresa(t);
        }
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const dataGerencia = () => {
    setGerencia([]);
    OrganigramaService.organigramaByTipo("01", filterGerencia)
      .then((res) => {
        if (res.status == 200) {
          let t: IItemComboBaseDTO[] = res.data;
          t.unshift(ItemNoneSelect());

          setGerencia(t);
        }
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const dataLugarMovilizacion = () => {
    ProgramacionService.allLugarMovilizacion1(filterLugarMovilizacion)
      .then((res) => {
        setLugarMovilizacion(res.data);
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
      });
  };

  const _clearSearch = (type: string) => {
    switch (type) {
      case "bus":
        setSelBusForm(null!);

        setFilterBusVigente({
          ...filterBusVigente,
          search: "",
        });
        break;
      case "campamento":
        setFilterCampamento({
          ...filterCampamento,
          search: "",
        });
        break;
      case "empresa":
        setFilterEmpresa({
          ...filterEmpresa,
          search: "",
        });
        break;
      case "gerencia":
        setFilterGerencia({
          ...filterGerencia,
          search: "",
        });
        break;
      case "LugarMovilizacion":
        setFilterLugarMovilizacion({
          ...filterLugarMovilizacion,
          search: "",
        });
        break;
      default:
        break;
    }
  };

  const _onChangeCombo = (
    type: string,
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        let k: string | null = null;

        let isNone = option.key == IndexNone;

        if (isNone) {
          _clearSearch(type);
        }

        switch (type) {
          case "bus":
            if (!isNone) {
              setSelBusForm(option);
            }

            break;
          case "campamento":
            if (!isNone) {
              k = String(option.key);
            }

            setFilter({
              ...filter,
              campamentoId: k,
            });
            break;
          case "empresa":
            if (!isNone) {
              k = String(option.key);
            }

            setFilter({
              ...filter,
              empresaPersonaId: k,
            });
            break;
          case "gerencia":
            if (!isNone) {
              k = String(option.key);
            }
            setFilter({
              ...filter,
              gerenciaId: k,
            });
            break;
          case "LugarMovilizacion":
            if (!isNone) {
              k = String(option.key);
            }
            setFilter({
              ...filter,
              lugarMovilizacionId: k,
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const _onBlurCombo = (type: string) => {
    switch (type) {
      case "bus":
        if (selBusForm == undefined && selBusForm != null) {
        }
        break;
      case "campamento":
        if (
          (filter.campamentoId == "" ||
            filter.campamentoId == undefined) &&
          filter.campamentoId != null
        ) {
          setFilter({
            ...filter,
            campamentoId: null,
          });
        }
        break;
      case "empresa":
        if (
          (filter.empresaPersonaId == "" || filter.empresaPersonaId == undefined)
        ) {
          setFilter({
            ...filter,
            empresaPersonaId: null,
          });
        }
        break;
      case "gerencia":
        if (
          (filter.gerenciaId == "" || filter.gerenciaId == undefined) &&
          filter.gerenciaId != null
        ) {
          setFilter({
            ...filter,
            gerenciaId: null,
          });
        }
        break;
      case "LugarMovilizacion":
        if (
          (filter.lugarMovilizacionId == "" ||
            filter.lugarMovilizacionId == undefined) &&
          filter.lugarMovilizacionId != null
        ) {
          setFilter({
            ...filter,
            lugarMovilizacionId: null,
          });
        }
        break;
      default:
        break;
    }
  };

  /* Hook */
  useEffect(() => {
    if (programacionId != null) {
      reloadInitial();
    }
  }, []);

  /* Hook Pagination */
  useEffect(() => {
    setPager({
      ...pager,
      currentPage: currentPage,
    });

    if (filter) {
      setFilter({
        ...filter,
        skip: (currentPage - 1) * pageSize,
        take: pageSize,
      });
    }
  }, [currentPage]);

  useEffect(() => {
    setPager({
      ...pager,
      onPageChange: (page) => dataByPager(page),
      onSizeChange: (pageSize) => setPageSize(pageSize),
      total: total,
    });
  }, [total]);

  /* Api */
  const dataInscrito = (param = filter) => {
    if (programacionId != '') {
      setData(_initialDataCollection);
      ProgramacionPersonaService.inscritoTransporte(param)
        .then((res) => {
          if (res.status == 200) {
            setData(res.data);
            setHidden(true);
            setTotal(res.data.total);
          }
        })
        .catch((e: IException) => {
          alert(splitExceptionDetail(e));
          setHidden(true);
        });
    }
  }

  /* Function */
  const reloadInitial = (param = filter) => {
    setHidden(false);
    setTitleColumn();
    dataInscrito(param);
  }

  useEffect(() => {
    if (isOpenFiltro) {
      dataCampamento();
      dataEmpresa();
      dataGerencia();
      dataLugarMovilizacion();
    }
  }, [isOpenFiltro])

  const _leftBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () => { navigate(`${ConfigHelper.urlBase()}/empresa.transporte`) },
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: () => reloadInitial(),
      },
    ];

    return _items;
  };

  const _rightBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_EXCEL,
        onClick: openTelerik,
      },
      {
        ...IconHelper.ICON_FILTER,
        text: "Filtrar",
        onClick: () => {
          openFiltro();
        },
      },
    ];

    return _items;
  };

  const setTitleColumn = () => {
    let col: IColumn[] = [
      {
        key: "column1",
        name: "Foto",
        ariaLabel:
          "Column operations for File type, Press to sort on File type",
        isIconOnly: true,
        fieldName: "foto",
        minWidth: 45,
        maxWidth: 45,
        onRender: (item: IProgramacionPersona) => (
          <TooltipHost content={`Foto`}>
            <Persona
              text=""
              size={PersonaSize.size24}
              imageUrl={baseImageUrl}
            />
          </TooltipHost>
        ),
      },
      {
        key: "column2",
        name: "Nombre",
        fieldName: "nombres",
        minWidth: 160,
        maxWidth: 200,
        isRowHeader: true,
        isResizable: true,
        isSorted: false,
        isSortedDescending: false,
        sortAscendingAriaLabel: "Sorted A to Z",
        sortDescendingAriaLabel: "Sorted Z to A",
        data: "string",
        isPadded: true,
        onRender: (item: IProgramacionPersona) => {
          return (
            <span
              style={{
                fontSize: "90%",
                textDecorationLine:
                  item.motivoRetiro == "" ? "none" : "line-through",
              }}
            >
              {item.nombres}
            </span>
          );
        },
      },
      {
        key: "column3",
        name: "Identificación",
        fieldName: "nroDOI",
        minWidth: 80,
        maxWidth: 90,
        isResizable: true,
        data: "number",
        isPadded: true,
        onRender: (item: IProgramacionPersona) => {
          return (
            <span
              style={{ fontSize: "95%" }}
            >{`${item.tipoDocumento} ${item.nroDOI}`}</span>
          );
        },
      },
      {
        key: "column40",
        name: "Gerencia",
        fieldName: "gerencia",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
      {
        key: "column41",
        name: "Email",
        fieldName: "email",
        minWidth: 170,
        maxWidth: 180,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
      {
        key: "column5",
        name: "Celular",
        fieldName: "celular",
        minWidth: 70,
        maxWidth: 70,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column9.1",
        name: "Empresa Persona",
        fieldName: "empresa",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column10",
        name: "Empresa Transportista",
        fieldName: "transporte",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        onRender: (item) => {
          return (
            <span
              style={{ fontSize: "95%" }}
            >{`${item.transporte ? item.transporte : "No asignado"}`}</span>
          );
        },
      },
      {
        key: "column11",
        name: "Turno",
        fieldName: "turno",
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column12",
        name: "Usuario Registra",
        fieldName: "nombreUsuarioRegistra",
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column14",
        name: "En Espera",
        fieldName: "enEspera",
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column14.1",
        name: "Es Adicional",
        fieldName: "esAdicional",
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
      },
      {
        key: "column14.2",
        name: "Es Comunidad",
        fieldName: "esComunidad",
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        onRender: (item) => {
          return (
            <span
              style={{ fontSize: "95%" }}
            >{`${item.esComunidad ? "Si" : "No"}`}</span>
          );
        },
      },
      {
        key: "column16",
        name: "Proceso - Estado",
        fieldName: "nivelActual",
        minWidth: 250,
        maxWidth: 250,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
      {
        key: "column18",
        name: "Lugar Movilización",
        fieldName: "lugarMovilizacion",
        minWidth: 200,
        maxWidth: 200,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
      {
        key: "column6",
        name: "Origen",
        fieldName: "origen",
        minWidth: 90,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column6",
        name: "Destino",
        fieldName: "destino",
        minWidth: 90,
        maxWidth: 90,
        isResizable: true,
        isCollapsible: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column19",
        name: "Centro Costo",
        fieldName: "centroCosto",
        minWidth: 150,
        maxWidth: 160,
        isResizable: true,
        isCollapsible: true,
        data: "number",
      },
    ];

    setColumn(col);
  };

  /* Event Tab */
  const dataByPager = (page) => {
    if (true) {
      setTotal(0);

      setPager({
        ...pager,
        currentPage: page,
      });

      let f: IFilterProgramacion = {
        ...filter,
        skip: (page - 1) * pageSize,
        take: pageSize,
      }

      setFilter(f);
      setCurrentPage(page);

      reloadInitial(f);
    }
  }

  useEffect(() => {
    if (filtroTabla) {
      setHidden(false);
      dataInscrito();
      setFiltroTabla(false);
    }
  }, [filtroTabla]);

  const handleFiltrar = () => {
    setFiltroTabla(true);
  };

  const _onRenderFooterFiltro = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={handleFiltrar}
          styles={ThemeBase.panelButtonStyle}
        >
          Filtrar
        </PrimaryButton>
        <DefaultButton onClick={dismissFiltro}>Cancelar</DefaultButton>
      </div>
    ),
    [dismissFiltro]
  );

  const _onChangeInput = (type: string, event, newValue) => {
    const value = event.target.value;

    switch (type) {
      case "nroDOI":
        if (newValue.length > 0) {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nroDOI: value
          });
        } else {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nroDOI: null
          });
        }
        break;
      case "nombre":
        if (newValue.length > 0) {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nombre: value
          });
        } else {
          setFilter({
            ...filter,
            programacionId: programacionId,
            nombre: null
          });
        }
        break;
    }
  };

  return (
    <>
      <TableBase leftBar={_leftBar()} rigthBar={_rightBar()} column={column} data={data.items} pagination={pager} style={ThemeBase.notPaddingTableBase} isLoading={!hidden}></TableBase>

      <Panel
        isOpen={isOpenFiltro}
        onDismiss={dismissFiltro}
        headerText={`Filtrado`}
        closeButtonAriaLabel="Close"
        onRenderFooterContent={_onRenderFooterFiltro}
        isFooterAtBottom={true}
      >
        <>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <br />
              <div
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                style={ThemeBase.notPaddingSide}
              >
                <TextField
                  label="Documento de Identidad"
                  name="nroDOI"
                  type="text"
                  placeholder="Ingrese el dni"
                  onChange={(e, o) => _onChangeInput("nroDOI", e, o)}
                  defaultValue={filter.nroDOI ?? ""}
                  minLength={8}
                  maxLength={8}
                />
                <br />
                <TextField
                  label="Nombre"
                  name="nombre"
                  type="text"
                  placeholder="Ingrese el nombre"
                  onChange={(e, o) => _onChangeInput("nombre", e, o)}
                  defaultValue={filter.nombre ?? ""}
                />
                <br />
                <ComboBox
                  label="Destino:"
                  componentRef={refCampamento}
                  placeholder="Seleccione Destino"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={campamento}
                  onInput={_onInputDestino}
                  selectedKey={filter.campamentoId}
                  onChange={(e, o) => _onChangeCombo("campamento", e, o)}
                  onBlur={() => _onBlurCombo("campamento")}
                />
                <br />
                <ComboBox
                  label="Empresa Persona:"
                  componentRef={refEmpresa}
                  placeholder="Seleccione Empresa Persona"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={empresa}
                  onInput={_onInputEmpresa}
                  selectedKey={filter.empresaPersonaId}
                  onChange={(e, o) => _onChangeCombo("empresa", e, o)}
                  onBlur={() => _onBlurCombo("empresa")}
                />
                <br />
                <ComboBox
                  label="Gerencia:"
                  componentRef={refGerencia}
                  placeholder="Seleccione Gerencia"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={gerencia}
                  onInput={_onInputGerencia}
                  selectedKey={filter.gerenciaId}
                  onChange={(e, o) => _onChangeCombo("gerencia", e, o)}
                  onBlur={() => _onBlurCombo("gerencia")}
                />
                <br />
                <ComboBox
                  label="Lugar Movilización:"
                  componentRef={refLugarMovilizacion}
                  placeholder="Seleccione Lugar Movilización"
                  allowFreeform
                  autoComplete="off"
                  useComboBoxAsMenuWidth
                  calloutProps={{ directionalHintFixed: true }}
                  options={lugarMovilizacion}
                  onInput={_onInputLugarMovilizacion}
                  selectedKey={filter.lugarMovilizacionId}
                  onChange={(e, o) => _onChangeCombo("LugarMovilizacion", e, o)}
                  onBlur={() => _onBlurCombo("lugarMovilizacion")}
                />
              </div>
            </div>
          </div>
        </>
      </Panel>

      {/* Panel - Reporte - Telerik */}
      <RepoteBaseGenerico
        NameReport={reportTelerik.reportName}
        Parameters={reportTelerik.param}
        openTelerik={isOpenTelerik}
        dismissTelerik={dismissTelerik}
      ></RepoteBaseGenerico>
    </>
  )
}